
import { AdminUser, User } from "../contexts/auth/types";
import { get, patch, post, del } from './apiService';

// Type for the query params
interface UserQueryParams {
  search?: string;
  role?: string;
  status?: string;
  page?: number;
  itemsPerPage?: number;
}

export const fetchUsers = async (params?: UserQueryParams): Promise<AdminUser[]> => {
    console.log('Fetching users from API with params:', params);

    try {
        // Build query parameters
        let queryString = '';
        if (params) {
            const urlParams = new URLSearchParams();
            if (params.search) urlParams.append('search', params.search);
            if (params.role) urlParams.append('role', params.role);
            if (params.status) urlParams.append('status', params.status);
            if (params.page) urlParams.append('page', params.page.toString());
            if (params.itemsPerPage) urlParams.append('itemsPerPage', params.itemsPerPage.toString());
            
            queryString = urlParams.toString();
        }

        // Append query string to endpoint if available
        const endpoint = queryString ? `/users?${queryString}` : '/users';
        const response = await get<User[]>(endpoint);
        console.log('Users data received:', response.data);

        // Extract users from hydra:member array if available
        return (response.data as any)['hydra:member'] || response.data;
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error;
    }
};

export const getUserById = async (userId: string): Promise<AdminUser> => {
    try {
        const response = await get<AdminUser>(userId);
        return response.data;
    } catch (error) {
        console.error(`Error fetching user ${userId}:`, error);
        throw error;
    }
};

export const updateUser = async (iri: string, userData: Partial<AdminUser>): Promise<AdminUser> => {
    try {
        // Use the IRI as the endpoint for updating the specific user
        const response = await patch<AdminUser>(iri, userData);
        return response.data;
    } catch (error) {
        console.error('Error updating user:', error);
        throw error;
    }
};

export const createUser = async (userData: Partial<User>): Promise<AdminUser> => {
    try {
        const response = await post<AdminUser>('/users', userData);
        return response.data;
    } catch (error) {
        console.error('Error creating user:', error);
        throw error;
    }
};

export const deleteUser = async (iri: string): Promise<void> => {
    try {
        // Use the IRI as the endpoint for deleting the specific user
        await del(iri);
    } catch (error) {
        console.error('Error deleting user:', error);
        throw error;
    }
};
